module.exports = __webpack_public_path__ + "img/international_compare.854e48ad.jpg";